import React, { useState } from "react";
import { Checkbox, message, Spin } from "antd";
import type { CheckboxChangeEvent } from "antd/es/checkbox";
import { GraphQLClient, gql } from "graphql-request";
import { GRAPHQL_API_URL } from "App";
import { AppConfig } from "app.config";

interface ToggleCardTypeProps {
    cardId: string;
    isPhysicalCard: boolean;
}

const TOGGLE_CARD_TYPE_MUTATION = gql`
  mutation toggleCardTypeOfIndusIndCardForInternalPortal($input: ToggleCardTypeOfIndusIndCardInput!) {
    toggleCardTypeOfIndusIndCardForInternalPortal(input: $input)
  }
`;


export const ToggleCardType: React.FC<ToggleCardTypeProps> = ({
    cardId,
    isPhysicalCard: initialIsPhysicalCard,
}) => {
    const [isPhysicalCard, setIsPhysicalCard] = useState(initialIsPhysicalCard);
    const [loading, setLoading] = useState(false);

    const handleChange = async (e: CheckboxChangeEvent) => {
        if (loading) return;

        const newValue = e.target.checked;
        setLoading(true);

        try {
            const client = new GraphQLClient(GRAPHQL_API_URL, {
                headers: {
                    Authorization: `Bearer ${sessionStorage.getItem(AppConfig.apiTokenKey)}`,
                },
            });

            const variables = {
                input: {
                    cardId,
                    isPhysicalCard: newValue,
                },
            };
            const response = await client.request(TOGGLE_CARD_TYPE_MUTATION, variables);

            const messageText =
                response?.toggleCardTypeOfIndusIndCard ?? `Card type updated successfully`;
            message.success(messageText);
            setIsPhysicalCard(newValue);
        } catch (err: any) {
            console.error(err);
            message.error(err?.response?.errors?.[0]?.message || `Something went wrong`);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <span>Physical card issued?</span>
            <Spin spinning={loading}>
                <Checkbox
                    checked={isPhysicalCard}
                    onChange={handleChange}
                    disabled={loading}
                />
            </Spin>
        </div>
    );
};
